import { cx } from './cx';
import styles from './StatusIndicator.module.css';

export type StatusTone = 'neutral' | 'success' | 'warning' | 'danger';

interface StatusIndicatorProps {
  readonly tone?: StatusTone;
  readonly label: string;
}

/** Colored dot + text. The text always carries the meaning; color is only reinforcement. */
export function StatusIndicator({ tone = 'neutral', label }: StatusIndicatorProps) {
  return (
    <span className={styles.indicator}>
      <span aria-hidden="true" className={cx(styles.dot, styles[tone])} />
      {label}
    </span>
  );
}
